import React from 'react'

interface KeypadProps {
  onKeyPress: (key: string) => void
  onClear: () => void
  onDelete: () => void
}

export const Keypad: React.FC<KeypadProps> = ({ onKeyPress, onClear, onDelete }) => {
  const keys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['C', '0', '←'],
  ]

  const handleKey = (key: string) => {
    if (key === 'C') onClear()
    else if (key === '←') onDelete()
    else onKeyPress(key)
  }

  const isDelete  = (k: string) => k === '←'

  return (
    <div className="grid grid-cols-3 gap-2 w-full mb-5 select-none">
      {keys.flat().map((key) => (
        <button
          key={key}
          type="button"
          onPointerDown={(e) => { e.preventDefault(); handleKey(key) }}
          className={`
            flex items-center justify-center
            h-[54px] text-lg font-semibold
            rounded-xl transition-all duration-100
            active:scale-95
            touch-target
            ${isDelete(key)
              ? 'bg-[var(--surface-muted)] text-[var(--text-primary)] border border-[var(--border)] hover:border-[var(--border-strong)]'
              : key === 'C'
                ? 'bg-[var(--surface-muted)] text-[var(--kvh-red)] border border-[var(--border)] hover:border-[var(--border-strong)]'
                : 'bg-[var(--card)] text-[var(--text-primary)] border border-[var(--border)] shadow-[var(--shadow-xs)] hover:border-[var(--border-strong)] hover:shadow-[var(--shadow-sm)]'
            }
          `}
        >
          {key}
        </button>
      ))}
    </div>
  )
}
